import React from "react"
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { CustomDate } from "../CustomControls/CustomDateTime";
import { ErrorMessage } from "../Notifications/Notifications";
import { useTranslation } from "react-i18next";

// The labelled date fields are taller than the unlabelled filters they sit next to,
// so their row has to line its children up by the bottom edge.
export const dateRangeRowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end'
};

export function DateRangeComponent({ startDate, endDate, handleChange, name, disabled }) {
    const { t } = useTranslation()

    const onHandleFromChange = (e, v) => {
        const date = v.toDate();
        if (endDate != null && date > endDate) {
            ErrorMessage(t('settings.freezer.validDate'))
            return
        }
        handleChange({ to: endDate, from: date })
    }

    const onHandleToChange = (e, v) => {
        const date = v.toDate();
        if (date < startDate) {
            ErrorMessage(t('settings.freezer.validDate'))
            return
        }
        handleChange({ from: startDate, to: date })
    }

    return (
        <Row>
            <Col sm={12} md={6} style={{ minWidth: '7.5rem' }}>
                <ControlLabel>{t('commons.from')}</ControlLabel>
                <CustomDate
                    name={`${name}_from`}
                    onChange={onHandleFromChange}
                    onBlur={() => { }}
                    value={startDate}
                    dateFormat="DD/MM/YYYY"
                    disabled={disabled}
                    inputProps={{ placeholder: "DD/MM/YYYY" }}
                />
            </Col>
            <Col sm={12} md={6} style={{ minWidth: '7.5rem' }}>
                <ControlLabel>{t('commons.to')}</ControlLabel>
                <CustomDate
                    name={`${name}_to`}
                    onChange={onHandleToChange}
                    onBlur={() => { }}
                    value={endDate}
                    dateFormat="DD/MM/YYYY"
                    disabled={disabled}
                    inputProps={{ placeholder: "DD/MM/YYYY" }} />
            </Col>
        </Row>)
}